import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HMSCompanySelection from './pages/HMSCompanySelection';
import HMSReportTypeSelection from './pages/HMSReportTypeSelection';
import HMSIncidentForm from './pages/HMSIncidentForm';
import RUHForm from './pages/RUHForm';
import HMSConfirmation from './pages/HMSConfirmation';

const HMSModule = () => {
  return (
    <Routes>
      <Route path="/" element={<HMSCompanySelection />} />
      <Route path="company-selection" element={<HMSCompanySelection />} />
      {/* NY RUTE HER: */}
      <Route path="select-type" element={<HMSReportTypeSelection />} />
      <Route path="incident-form" element={<HMSIncidentForm />} />
      <Route path="ruh-form" element={<RUHForm />} />
      <Route path="confirmation" element={<HMSConfirmation />} />
    </Routes>
  );
};

export default HMSModule;